import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=70a2de6b&scoped=true"
import script from "./TermsConditions.vue?vue&type=script&lang=ts"
export * from "./TermsConditions.vue?vue&type=script&lang=ts"
import style0 from "./TermsConditions.vue?vue&type=style&index=0&id=70a2de6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a2de6b",
  null
  
)

export default component.exports